import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditPreventiveMaintenance() {
  const { id } = useParams();
  const [machines, setMachines] = useState([]);
  const [data, setData] = useState({
    machine_id: "",
    schedule_date: "",
    description: "",
    cost: "",
    completed: false
  });

  useEffect(() => {
    fetchMaintenance();
    fetchMachines();
  }, []);

  const fetchMaintenance = () => {
    axios.get(baseUrl + "preventive-maintenance/" + id + "/")
      .then(res => setData({
        machine_id: res.data.machine?.id || "",
        schedule_date: res.data.schedule_date,
        description: res.data.description,
        cost: res.data.cost,
        completed: res.data.completed
      }))
      .catch(() => Swal.fire("Error", "Could not fetch maintenance record", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/").then(res => setMachines(res.data));
  };

  const inputHandler = (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setData({ ...data, [e.target.name]: value });
  };

  const formSubmit = () => {
    const _formData = new FormData();
    _formData.append("machine", data.machine_id);
    _formData.append("description", data.description);
    _formData.append("schedule_date", data.schedule_date);
    _formData.append("cost", data.cost);
    _formData.append("completed", data.completed);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "preventive-maintenance/" + id + "/", _formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(() => Swal.fire({ title: "Updated", icon: "success", timer: 2000, showConfirmButton: false }))
      .then(() => window.location.href = "/preventive-maintenance/")
      .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Preventive Maintenance</h4>

        <select name="machine_id" value={data.machine_id} onChange={inputHandler} className="form-control mt-3">
          <option value="">Select Machine</option>
          {machines.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>
         <textarea
          className="form-control mt-3"
          placeholder="Description"
          name="description"
          value={data.description}
          onChange={inputHandler}
        />

        <input type="date" className="form-control mt-3" name="schedule_date" value={data.schedule_date} onChange={inputHandler} />
        <input type="number" className="form-control mt-3" placeholder="Cost" name="cost" value={data.cost} onChange={inputHandler} />
        <div className="form-check mt-3">
          <input type="checkbox" className="form-check-input" name="completed" checked={data.completed} onChange={inputHandler} />
          <label className="form-check-label">Completed</label>
        </div>

        <button className="btn btn-primary mt-3" onClick={formSubmit}>Update</button>
      </div>
    </div>
  );
}

export default EditPreventiveMaintenance;
